import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "space-between",
    gap: 33,
    [theme.breakpoints.up("sm")]: {
      gap: 6
    },
    [theme.breakpoints.up("md")]: {
      gap: 33
    },
    [theme.breakpoints.up("lg")]: {
      gap: 53
    }
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    padding: "4px 0",
    minWidth: 64,
    width: "calc(100% / 7)"
  },
  listItemText: {
    display: "block",
    textTransform: "uppercase",
    textAlign: "center",
    fontSize: 14,
    lineHeight: 1,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  listItemTextShort: {
    display: "none",
    fontSize: 12,
    lineHeight: 1,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.primary,
    textTransform: "uppercase",
    [theme.breakpoints.down("xs")]: {
      display: "block"
    }
  },
  picWrapper: {
    overflow: "hidden",
    height: 40,
    minHeight: 40,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      height: 30
    }
  },
  listItemIcon: {
    marginBottom: 8,
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 4
    }
  },
  temperature: {
    marginBottom: 8,
    fontSize: 14,
    lineHeight: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
      marginBottom: 4
    }
  },
  temperatureDay: {
    color: theme.palette.text.primary,
    margin: "0 2px"
  },
  temperatureNight: {
    color: theme.palette.text.hint,
    margin: "0 2px"
  },
  humidity: {
    width: "100%",
    height: 16,
    position: "relative",
    background: "rgba(238, 238, 238, 0.5)",
    [theme.breakpoints.down("xs")]: {
      height: 14
    }
  },
  humidityPercent: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    background: "rgba(99, 217, 255, 1)"
  },
  humidityText: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    fontSize: 12,
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
      paddingLeft: 8,
      paddingTop: 1
    }
  },
  humidityIcon: {
    position: "absolute",
    top: 1,
    left: 2,
    zIndex: 1,
    fontSize: 13,
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
      left: 0
    }
  },
  outOfServiceText: {
    display: "flex",
    minHeight: 78,
    height: "100%",
    color: theme.palette.primary.light,
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    fontSize: 14
  }
}));
